import { render, staticRenderFns } from "./ItemStoreSpecial.vue?vue&type=template&id=2a7c54db&"
import script from "./ItemStoreSpecial.vue?vue&type=script&lang=js&"
export * from "./ItemStoreSpecial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Projekte/woerner-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a7c54db')) {
      api.createRecord('2a7c54db', component.options)
    } else {
      api.reload('2a7c54db', component.options)
    }
    module.hot.accept("./ItemStoreSpecial.vue?vue&type=template&id=2a7c54db&", function () {
      api.rerender('2a7c54db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/woerner/ItemStoreSpecial.vue"
export default component.exports